import React, { useState, useEffect } from "react";
import { imageAlert } from "../../../components/SweetAlert";
import browserImageCoverter from "./BrowserImageCoverter ";
import LargeScreen from "../imagecompressor/LargeScreen";
import SmallScreen from "../imagecompressor/SmallScreen";
import TextSlicer from "../../../components/TextSlicer";
import "../sass/ImageCompress.scss";
import Detailtext from "../../../components/Detailtext";
import MetaData from "../../../components/MetaData";
import ButtonSpinner from "../../../components/ButtonSpinner";

const description = `A "WebP Converter" online tool is designed to convert image files from formats like PNG or JPG into the WebP format. This tool is ideal for users looking to reduce image file sizes without compromising much on quality, making it suitable for faster-loading websites and efficient storage.`;

const workingPoints = [
  "Upload Image: Users upload their PNG, JPG, or other image files they want to convert to WebP using the online tool.",
  "Compression and Conversion: The tool processes the uploaded image, applying advanced compression algorithms to convert it into the WebP format. This may include quality adjustments and optimization techniques.",
  "Output: The converted WebP image is generated, and users can download the optimized image in the new format.",
];

const benefitPoints = [
  "Smaller File Sizes: WebP offers superior compression compared to traditional formats like PNG and JPG, significantly reducing file sizes while maintaining quality.",
  "Faster Web Performance: Reduced image sizes lead to quicker page load times, enhancing user experience and SEO for websites.",
  "Lossy and Lossless Support: WebP supports both lossy and lossless compression, offering flexibility based on the use case.",
  "Modern Format: Designed specifically for the web by Google, making it a modern alternative for developers and designers.",
  "Animation and Transparency: WebP supports animated images and alpha transparency, combining the strengths of GIF and PNG in a single format.",
  "Efficient Storage: Smaller file sizes allow for better use of storage space, especially useful in mobile apps and cloud environments.",
  "High-Quality Output: Maintains strong visual quality even at lower file sizes, ideal for web publishing and mobile delivery.",
  "Cross-Browser Compatibility: Supported by most modern browsers including Chrome, Firefox, Edge, and Opera.",
  "Batch Conversion: Many tools allow converting multiple images to WebP at once, saving time for users working with large volumes.",
];

const WebpConverter = () => {
  const [files, setFiles] = useState([]);
  const [filename, setfilename] = useState("");
  const [file, setfile] = useState("");
  const [fileLink, setFileLink] = useState(false);
  const [urlImage, seturlImage] = useState("");
  const [loading, setLoading] = useState(false);

  const onDropImage = (acceptedFiles, fileRejections) => {
    if (fileRejections.length > 5) {
      imageAlert(
        "",
        "Please kindly drop five images or fewer for efficient processing"
      );
      return;
    } else {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    }
  };

  const readMultipleImages = async (files) => {
    await Promise.all(
      files.map(async (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener("load", (event) => {
          if (
            browserImageCoverter.downloadImageWithType(
              event.target.result,
              "WEBP", 
              file.name
            )
          ) {
          }
          setFiles([]);
          setLoading(false);
        });
      })
    );
  };

  const readSingleImage = (file) => {
    const reader = new FileReader();
    reader.addEventListener("load", (event) => {
      if (
        browserImageCoverter.downloadImageWithType(
          event.target.result,
          "WEBP", 
          file.name
        )
      ) {
      }
      setfile("");
      setLoading(false);
    });
    reader.readAsDataURL(file);
  };
  const isValidUrl = (input) => {
    // Regular expression for a valid URL
    const urlRegex =
      // eslint-disable-next-line no-useless-escape
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    return urlRegex.test(input);
  };

  const urlImageHandle = async (e) => {
    seturlImage(e.target.value);
    if (isValidUrl(e.target.value) && e.target.value !== "") {
      let urlImage = e.target.value;
      let extension = urlImage.replace(/^.*\./, "");
      if (extension === "png" || !urlImage.match(/^https:\/\//)) {
        setfilename(urlImage.substring(urlImage.lastIndexOf("/") + 1));
        try {
          const image = await fetch(urlImage).then((r) => r.blob());

          setfile(image);
        } catch (error) {
          console.log("Something went wrong " + error.message);
        }
      } else {
        setfilename("Invalid image type");
      }
    }
  };

  const convertBtn = async () => {
    try {
      setLoading(true);
      if (files) {
        readMultipleImages(files);
      }

      if (file) {
        readSingleImage(file);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const linkClickEvent = () => {
    setFileLink(!fileLink);
    setFiles([]);
    setfilename("");
    seturlImage("");
  };

  const closeUrlEvent = () => {
    setFileLink(false);
    setfilename("");
    setfile(null);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Make sure to revoke the data uris to avoid memory leaks, will run on unmount
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <>
      <MetaData
        metaTitle="WebP Converter"
        metaDescription="A WebP converter is an online tool designed to convert image files (like PNG or JPG) into the WebP format, which offers superior compression and faster web performance."
      />
      <div className="page_body">
        <div className="convert_tool_wrapper">
          <div className="pg_title">
            <h2>WebP Converter</h2>

            <TextSlicer text={description} />
          </div>
          {isMobile ? (
            <SmallScreen
              onDropImage={onDropImage}
              maxFiles={10}
            //   accept={{ "image/png": [] }}
              url={true}
              linkClickEvent={linkClickEvent}
              fileLink={fileLink}
              closeUrlEvent={closeUrlEvent}
              urlImage={urlImage}
              urlImageHandle={urlImageHandle}
            />
          ) : (
            <LargeScreen
              onDropImage={onDropImage}
              maxFiles={10}
            //   accept={{ "image/png": [] }}
              url={true}
              linkClickEvent={linkClickEvent}
              fileLink={fileLink}
              closeUrlEvent={closeUrlEvent}
              urlImage={urlImage}
              urlImageHandle={urlImageHandle}
            />
          )}
          <div className="text_right mt-2">
            <button
              className="btn convert_btn"
              onClick={convertBtn}
              disabled={(!files.length && !file) || loading}
            >
              Convert
              <span>
                {loading ? (
                  <ButtonSpinner />
                ) : (
                  <i className="ri-arrow-right-line"></i>
                )}
              </span>
            </button>
          </div>

          <div>
            <Detailtext
            workingText={"How a WebP Converter Online Tool Works:"}
            workingPoints={workingPoints}
            benefitText={"Key Benefits of Using a WebP Converter:"}
            benefitPoints={benefitPoints}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default WebpConverter;
